import { IKeywordEditItem, KeywordEditItem } from "./keywordEditItem";

export interface IKeywordEdit {
    item: IKeywordEditItem;
}

export class KeywordEdit implements IKeywordEdit {
    item: KeywordEditItem;

    constructor();
    constructor(obj: IKeywordEdit);
    constructor(obj?: any) {
        this.item = new KeywordEditItem(obj ? obj.item : null);
    }
}